import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { IconButton, MenuItem } from 'material-ui';
import ControlPointIcon from 'material-ui/svg-icons/image/control-point';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';

import { changePort } from 'actions/regions/ports';
import { Field, formValueSelector } from 'redux-form';
import { TextField, SelectField } from 'redux-form-material-ui';
import { numericality, required, length } from 'redux-form-validators';
import { formName } from 'data/formNames';

const styles = {
    textField: {
        floatingLabelStyle: { fontSize: '12px' },
    },
    icon: {
        color: 'rgb(0, 188, 212)',
    },
};

function Phones({ fields, countries = [] }) {
    const addPhone = useCallback(() => {
        fields.push('');
    }, [fields]);

    const filteredCountries = countries.filter(country => country.phoneCode && country.phoneCode[0]);

    return (
        <Fragment>
            {
                fields.map((field, index) => (
                    <div className="row" key={index}>
                        <div className="col-xs-4">
                            <Field
                                component={SelectField}
                                name={`${field}.code`}
                                floatingLabelText='Country'
                                floatingLabelStyle={styles.textField.floatingLabelStyle}
                                fullWidth
                                autoWidth
                                validate={required()}
                            >
                                {
                                    filteredCountries.map((country, key) => (
                                        <MenuItem
                                            key={key}
                                            value={country.phoneCode ? country.phoneCode[0] : ''}
                                            primaryText={`${country.phoneCode[0]} ${country.name}`}
                                        />
                                    ))
                                }
                            </Field>
                        </div>
                        <div className="col-xs-6">
                            <Field
                                component={TextField}
                                name={`${field}.phone`}
                                floatingLabelText='Phone number'
                                floatingLabelStyle={styles.textField.floatingLabelStyle}
                                fullWidth
                                validate={[required(), numericality({ int: true }), length({ min: 7, max: 15 })]}
                            />
                        </div>
                        <div className="col-xs-2 center-xs middle-xs" style={{ display: 'flex' }}>
                            {
                                index === 0
                                    ? (
                                        <IconButton
                                            iconStyle={styles.icon}
                                            onClick={addPhone}
                                        >
                                            <ControlPointIcon />
                                        </IconButton>
                                    )
                                    : (
                                        <IconButton
                                            iconStyle={styles.icon}
                                            onClick={() => {
                                                fields.remove(index);
                                            }}
                                        >
                                            <ContentRemoveIcon />
                                        </IconButton>
                                    )
                            }
                        </div>
                    </div>
                ))
            }
        </Fragment>
    );
}

Phones.propTypes = {
    port: PropTypes.object,
    fields: PropTypes.object.isRequired,
    countries: PropTypes.array,
};

Phones.defaultProps = {
    port: {},
    countries: [],
};

const selector = formValueSelector(formName.portUpdate);
export default connect(
    (state, ownProps) => ({
        ...ownProps,
        countries: state.countries.items,
        serviceProviders: selector(state, 'serviceProviders'),
    }),
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(Phones);



// WEBPACK FOOTER //
// ./app/components/Regions/Port/ServiceProviders/Phones.jsx